<template>
  <div>
    <h4 class="details-label mb-px-8 mt-0">{{ $t('study_sets.information') }}</h4>
    <create-study-set-overview :studysetDetails="studysetDetails" :organizationType="organizationType" :organizationId="organizationId" :uploadId="uploadId" @update:uploadId="$emit('update:uploadId', $event)" />
    <api-errors :errors="errors" />
    <h4 v-if="studysetDetails.assigned_group && studysetDetails.assigned_group.length" class="details-label mb-px-8 mt-px-16">{{ $t($i18nLabelsHelper(currentOrganizationType, `study_sets.assign_to_groups`)) }}</h4>
    <assign-to-class v-if="studysetDetails.assigned_group && studysetDetails.assigned_group.length" :studysetDetails="studysetDetails" :organizationType="organizationType" :organizationId="organizationId" :uploadId="uploadId" @update:uploadId="$emit('update:uploadId', $event)" />
  </div>
</template>


<script>
import ApiErrors from '@/components/common/ApiErrors'
import CreateStudySetOverview from './CreateStudySetOverview'
import AssignToClass from './AssignToClass'
import { always, isNil, path, dissoc, pathOr, length, compose, propOr, objOf, map } from 'ramda'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ApiErrors,
    CreateStudySetOverview,
    AssignToClass
  },
  props: {
    studysetDetails: {
      type: Object,
      default: always({ users: [] })
    },
    currentStep: {
      type: Number,
      default: 2
    },
    organizationType: {
      type: String,
      default: ''
    },
    uploadId: {
      default: null
    },
    organizationId: {}
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      errors: {},
      uploadDetails: {},
      primaryLoading: false
    }
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType'
    })
  },
  methods: {
    ...mapActions({
      createStudySetAction: 'studysets/createStudySet'
    }),
    openDisplayStudentsModal() {
      this.showStudentsModal = true
    },
    openImportUsersModal() {
      this.showImportModal = true
    },
    async createClass() {
      try {
        this.primaryLoading = true
        // if (this.uploadId) {
        //   const response = await this.createClassAction(
        //     dissoc("users", this.classDetails)
        //   );

        //   const groupId = path(["data", "id"], response);
        //   if (groupId) {
        //     await this.patchInviteUploadEmails({
        //       uploadId: this.uploadId,
        //       role: STUDENT,
        //       groupId: groupId
        //     });
        //     await this.postSentInviteUploadEmails({
        //       uploadId: this.uploadId,
        //       consent: this.classDetails.consent
        //     });
        //   }
        // } else {
        await this.createStudySetAction(this.studysetDetails)
        // }
        this.primaryLoading = false
        //return this.$emit('next-step', this.currentStep)
      } catch (error) {
        this.errors = error
        this.primaryLoading = false
      }
      return this.$emit('next-step', this.currentStep)
    },
    editClass() {
      this.$emit('edit-step')
    },
    cancelClass() {
      this.$emit('cancel')
    },
    ...mapActions('invite', ['postSentInviteUploadEmails', 'patchInviteUploadEmails', 'getInviteUploadEmails'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
.details-label {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 8px;
}
::v-deep .base-create-body {
  margin-top: 35px;
}

::v-deep .base-create-footer {
  margin-top: 24px;
}

::v-deep .generic-error-section {
  margin-bottom: 15px;
}
</style>
